/* Naoko — LP „Black Friday VIP — Disco” (docs/lp-bf-vip-disco-plan.md): JS skórki naoko-bfd-*.
   Silnik zapisu, ?typ=1, filmu hero, wjazdu, kotwic i kopiowania to assets/naoko-vip.js; tu tylko:
   - niebo: canvas wielkości ekranu w każdej sekcji ([data-bfd-sky], position: fixed, przycięty
     do sekcji), gwiazdy w układzie sekcji, rysowane z przesunięciem przewijania — wygląd jak
     w makiecie (jeden canvas na całą stronę), ale bez ogromnego płótna; rysowane tylko, gdy sekcja
     jest na ekranie; przy prefers-reduced-motion bez migotania (rysowanie przy przewijaniu),
   - przewijana opowieść (naoko-bfd-fall): slajd wg postępu przewijania (3 slajdy: progi z makiety
     30% / 62%, inna liczba: równe odcinki), meteory przy zmianie slajdu i co 1,5–2,4 s,
   - zapis: konstelacja i gwiazdki pól (is-lit / is-fine), przycisk is-ready, konfetti po ?typ=1,
   - animacje CSS sekcji wstrzymane poza ekranem (klasa is-off).
   Każda sekcja dołącza ten skrypt — blokada drugiego uruchomienia. */
(function () {
  if (window.NaokoBfd) return;
  window.NaokoBfd = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var C = ['#FF66C4', '#FF9AD8', '#C9B8FF', '#9EE7FF', '#FFFFFF'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function dpr() { return Math.min(window.devicePixelRatio || 1, 2); }
  function still() { return reduced.matches; }

  /* ---------------- Wspólna pętla (niebo + meteory) ---------------- */
  var jobs = [];
  var raf = 0;
  var tick = 0;
  function loop() {
    raf = 0;
    var any = false;
    tick++;
    jobs.forEach(function (j) { if (j.vis && j.el.isConnected) { j.frame(tick); any = true; } });
    if (any && !still()) raf = requestAnimationFrame(loop);
  }
  function wake() { if (!raf && !still()) raf = requestAnimationFrame(loop); }
  window.addEventListener('scroll', function () {
    if (!still()) return;
    jobs.forEach(function (j) { if (j.vis && j.still) j.still(); });
  }, { passive: true });
  var visIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      jobs.forEach(function (j) { if (j.watch === en.target) j.vis = en.isIntersecting; });
    });
    wake();
    jobs.forEach(function (j) { if (j.vis && j.still) j.still(); });
  }) : null;
  function addJob(j) {
    jobs.push(j);
    if (visIO) visIO.observe(j.watch);
    else { j.vis = true; wake(); }
  }

  /* ---------------- Niebo ---------------- */
  function initSky(cv) {
    if (cv.dataset.bfdReady) return;
    cv.dataset.bfdReady = '1';
    var sec = cv.parentElement;
    var cx = cv.getContext && cv.getContext('2d');
    if (!cx || !sec) return;
    var stars = [], W = 0, H = 0, SW = 0, SH = 0;

    function gen() {
      SW = sec.offsetWidth;
      SH = sec.offsetHeight;
      var n = Math.round(SW * SH / 5200);
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * SW, y: Math.random() * SH, r: Math.random() * 1.4 + 0.3, c: C[Math.random() * C.length | 0], p: Math.random() * 6.28, s: Math.random() * 0.03 + 0.008, f: Math.random() < 0.06 });
      }
    }
    function size() {
      var d = dpr();
      W = cv.clientWidth;
      H = cv.clientHeight;
      cv.width = W * d;
      cv.height = H * d;
      cx.setTransform(d, 0, 0, d, 0, 0);
    }
    function draw(t) {
      cx.clearRect(0, 0, W, H);
      var r = sec.getBoundingClientRect();
      var st = still();
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        var y = r.top + s.y;
        if (y < -14 || y > H + 14) continue;
        var x = r.left + s.x;
        var a = st ? 0.8 : 0.35 + 0.65 * Math.abs(Math.sin(s.p + t * s.s));
        cx.globalAlpha = a;
        cx.fillStyle = s.c;
        cx.beginPath(); cx.arc(x, y, s.r, 0, 6.28); cx.fill();
        if (s.f) {
          var l = s.r * 7 * a;
          cx.strokeStyle = s.c; cx.lineWidth = 0.8;
          cx.beginPath(); cx.moveTo(x - l, y); cx.lineTo(x + l, y); cx.moveTo(x, y - l); cx.lineTo(x, y + l); cx.stroke();
        }
      }
      cx.globalAlpha = 1;
    }
    var lastW = 0, lastH = 0;
    function refresh() {
      size();
      if (sec.offsetWidth !== lastW || Math.abs(sec.offsetHeight - lastH) > 40) {
        lastW = sec.offsetWidth;
        lastH = sec.offsetHeight;
        gen();
      }
      draw(tick);
    }
    refresh();
    window.addEventListener('resize', refresh);
    if ('ResizeObserver' in window) new ResizeObserver(refresh).observe(sec);
    addJob({ el: cv, watch: sec, vis: false, frame: draw, still: function () { draw(tick); } });
  }

  /* ---------------- Przewijana opowieść + meteory ---------------- */
  function initFall(root) {
    if (root.dataset.bfdReady) return;
    root.dataset.bfdReady = '1';
    var items = [].slice.call(root.querySelectorAll('.nbfd-rs > li'));
    var dots = [].slice.call(root.querySelectorAll('.nbfd-rd > i'));
    var mc = root.querySelector('.nbfd-met');
    var mx = mc && mc.getContext && mc.getContext('2d');
    var meteors = root.hasAttribute('data-bfd-meteors') && !!mx;
    var MW = 0, MH = 0, M = [], cur = 0, last = 0;
    var N = items.length;
    if (!N) return;

    function msize() {
      if (!mc || !mc.offsetWidth || !mx) return;
      var d = dpr();
      MW = mc.offsetWidth;
      MH = mc.offsetHeight;
      mc.width = MW * d;
      mc.height = MH * d;
      mx.setTransform(d, 0, 0, d, 0, 0);
    }
    function spawn(big) {
      if (!meteors || still()) return;
      var a = Math.PI * (0.72 + Math.random() * 0.08), sp = (MW < 760 ? 7 : 10) + Math.random() * 5;
      M.push({ x: MW * (0.25 + Math.random() * 0.9), y: -40 - Math.random() * MH * 0.2, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, len: (big ? 260 : 140) + Math.random() * 120, w: big ? 1.8 : 1.1, l: 1, c: Math.random() < 0.35 ? '255,154,216' : '255,255,255' });
    }
    function mdraw() {
      mx.clearRect(0, 0, MW, MH);
      for (var i = 0; i < M.length; i++) {
        var m = M[i];
        m.x += m.vx; m.y += m.vy;
        if (m.y > MH * 0.55) m.l -= 0.02;
        var k = Math.hypot(m.vx, m.vy), tx = m.x - m.vx / k * m.len, ty = m.y - m.vy / k * m.len;
        var g = mx.createLinearGradient(m.x, m.y, tx, ty);
        g.addColorStop(0, 'rgba(' + m.c + ',' + (0.95 * m.l) + ')');
        g.addColorStop(1, 'rgba(' + m.c + ',0)');
        mx.strokeStyle = g; mx.lineWidth = m.w; mx.lineCap = 'round';
        mx.beginPath(); mx.moveTo(m.x, m.y); mx.lineTo(tx, ty); mx.stroke();
        mx.fillStyle = 'rgba(255,255,255,' + m.l + ')';
        mx.beginPath(); mx.arc(m.x, m.y, m.w * 1.1, 0, 6.28); mx.fill();
      }
      M = M.filter(function (m) { return m.l > 0 && m.y < MH + 300 && m.x > -400; });
    }
    function setIdx(i) {
      if (i === cur) return;
      items.forEach(function (li, k) { li.classList.toggle('is-on', k === i); li.classList.toggle('is-past', k < i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      cur = i;
      spawn(true);
      if (Math.random() < 0.6) setTimeout(function () { spawn(false); }, 180);
    }
    function idxFor(p) {
      if (N === 3) return p < 0.3 ? 0 : p < 0.62 ? 1 : 2;
      return Math.min(N - 1, Math.floor(p * N));
    }
    function onScroll() {
      var r = root.getBoundingClientRect(), span = r.height - window.innerHeight;
      if (span <= 0) return;
      setIdx(idxFor(Math.min(1, Math.max(0, -r.top / span))));
    }
    msize();
    window.addEventListener('resize', function () { msize(); onScroll(); });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (meteors) {
      addJob({
        el: root,
        watch: root,
        vis: false,
        frame: function () {
          var now = performance.now();
          if (now - last > 1500 + Math.random() * 900) { spawn(false); last = now; }
          mdraw();
        }
      });
    }
  }

  /* ---------------- Zapis: konstelacja, gotowość, konfetti ---------------- */
  function initZapis(root) {
    if (root.dataset.bfdReady) return;
    root.dataset.bfdReady = '1';
    var card = root.querySelector('.nbfd-card');
    var cst = root.querySelector('.nbfd-cst');
    var nm = root.querySelector('[data-vip-field="fname"]');
    var em = root.querySelector('[data-vip-field="email"]');
    var cb = root.querySelector('[data-vip-field="consent"]');
    var go = root.querySelector('.nbfd-btn');
    if (card && nm && em && cb) {
      var lines = cst ? [].slice.call(cst.querySelectorAll('.nbfd-cl')) : [];
      var star = function (k, on) {
        var g = cst && cst.querySelector('[data-k="' + k + '"]');
        if (g) g.classList.toggle('is-lit', on);
      };
      var check = function () {
        var s = { imie: nm.value.trim().length > 1, email: EMAIL_RE.test(em.value.trim()), zgoda: cb.checked };
        star('imie', s.imie); star('email', s.email); star('zgoda', s.zgoda);
        var f1 = nm.closest('[data-vip-fld]'), f2 = em.closest('[data-vip-fld]');
        if (f1) f1.classList.toggle('is-fine', s.imie);
        if (f2) f2.classList.toggle('is-fine', s.email);
        if (lines[0]) lines[0].classList.toggle('is-lit', s.imie && s.email);
        if (lines[1]) lines[1].classList.toggle('is-lit', s.email && s.zgoda);
        if (go) go.classList.toggle('is-ready', s.imie && s.email && s.zgoda);
      };
      nm.addEventListener('input', check);
      em.addEventListener('input', check);
      cb.addEventListener('change', check);
      check();
      setTimeout(check, 600); /* autouzupełnianie przeglądarki */
    }
    if (root.classList.contains('is-typ') && card && !still()) setTimeout(function () { burst(card); }, 700);
  }

  function burst(card) {
    var bc = card.querySelector('.nbfd-burst');
    var bx = bc && bc.getContext && bc.getContext('2d');
    if (!bx) return;
    var d = dpr();
    var w = bc.width = card.offsetWidth * d, h = bc.height = card.offsetHeight * d;
    var P = [];
    for (var i = 0; i < 140; i++) {
      P.push({ x: w / 2, y: h * 0.18, vx: (Math.random() - 0.5) * 14 * d, vy: (Math.random() - 0.8) * 12 * d, r: (Math.random() * 2.6 + 1) * d, c: C[Math.random() * C.length | 0], l: 1 });
    }
    (function f() {
      bx.clearRect(0, 0, w, h);
      var alive = 0;
      for (var k = 0; k < P.length; k++) {
        var p = P[k];
        if (p.l <= 0) continue;
        alive++;
        p.x += p.vx; p.y += p.vy; p.vy += 0.28 * d; p.vx *= 0.985; p.l -= 0.012;
        bx.globalAlpha = Math.max(p.l, 0);
        bx.fillStyle = p.c;
        bx.fillRect(p.x, p.y, p.r, p.r);
      }
      if (alive) requestAnimationFrame(f);
      else bx.clearRect(0, 0, w, h);
    })();
  }

  /* ---------------- Animacje CSS poza ekranem ---------------- */
  var offIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target.classList.toggle('is-off', !en.isIntersecting); });
  }, { rootMargin: '100px 0px' }) : null;

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('[data-bfd-sky]').forEach(initSky);
    r.querySelectorAll('.nbfd-fall').forEach(initFall);
    r.querySelectorAll('.nbfd-zapis').forEach(initZapis);
    if (offIO) {
      r.querySelectorAll('.nbfd[data-bfd-anim]').forEach(function (el) {
        if (el.dataset.bfdAnimReady) return;
        el.dataset.bfdAnimReady = '1';
        offIO.observe(el);
      });
    }
  }

  init();
  if (reduced.addEventListener) reduced.addEventListener('change', wake);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
